<template>
  <div class="arrangeListDiv">
    <div style="padding: 26px; background: #fff">
      <div class="reviewListBtn">
        <el-button type="primary" size="small" @click="handleRow('goPs')"
          >评审表<span v-if="!judgeInfo?.signature_url">（未签名）</span></el-button
        >
      </div>
      <div
        class="reviewListContent"
        v-for="(item,index) in tableData"
        :key="item.xid"
          @click="handleRow('look',item)"
      >
        <div class="reviewListLeft">
          <div class="name">{{index + 1}}</div>
          <!-- <div>
            <img src="@/assets/menu4.png" alt="" class="headImg" />
          </div> -->
          <div class="nameTitle">{{item.project_name}}</div>
           <div class="name">{{item.declarant_name}}</div>

        </div>
        <div class="reviewListLeft">
          <div class="name">得分：{{item.total_score}}</div>
          <div class="status" :style="getStatusStyle(item.status)">{{getStatusText(item.status)}}</div>

          <!-- <div>
                        <el-button
                type="primary"
                size="small"
                @click="handleRow('look',item)"
                >查看</el-button
              >
             
          </div> -->
                    <!-- <div>
                     <el-button
                     style="margin-left: 10px;"
                type="primary"
                size="small"
                @click="handleRow('upload',item)"
                >上传</el-button
              >
          
          </div> -->
        </div>
      </div>
     <div class="paginBox">
      <div class="countNumber">
        共{{ total }}条
      </div>
      <div class="rightPagin">
        <el-pagination @size-change="sizePagination" :current-page="filter.currPage" @current-change="currentPagination"
          :page-size="filter.pageSize" background layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
      <div class="goBack">
        <div class="goBackBtn">
          <el-button type="primary" size="small" @click="handleRow('goBack')"
            >返回</el-button
          >
        </div>
      </div>
    </div>

        <el-dialog
      title="上传文件"
      :visible.sync="uploadDialogVisible"
      width="500px"
      :before-close="closeUploadDialog"
    >
    <div style="padding:15px 0;font-size:20px;text-align: center;">请确认上传的签名图片的准确性</div>
      <el-upload
        class="upload"
        style="width: 100%"
        drag
        :action="`${baseURL}/common/uploadFile`"
        :on-success="handleSuccess"
        :on-remove="handleRemove"
        :on-preview="handlePreview"
        :limit="1"
        :file-list="uploadFileList"
        accept=".jpg,.jpeg,.png"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
        <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpload">确认上传</el-button>
        <el-button @click="closeUploadDialog">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getBaseUrl } from '@/config'
export default {
  name: "ReviewList",
  data() {
    return {
        baseURL: getBaseUrl(),
      uploadDialogVisible: false,
      uploadFileList: [],
      currentUploadRow: null,
      total: 0,
      filter: {
        xid: "",
        currPage: 1,
        pageSize: 5,
      },
      tableData: [],
      judgeInfo:{}
    };
  },
  mounted() {
    this.filter.xid = this.$route.query.xid;
    this.getList();
    this.getInfo()
  },

  methods: {
      getInfo(){
        this.$API.getJudgeProject({
        arrange_xid: this.filter.xid,
      }).then(res => {
        this.judgeInfo = res.data
             console.log("res=========",res)
      })
      },
        handleRemove(e) {
      console.log("e=========", e);
      this.uploadFileList = this.uploadFileList.filter(
        (item) => item.url !== e.url
      );

    },
    handlePreview(e) {
      window.open(e.url, "_blank");
    },
    handleSuccess(e) {
      this.uploadFileList.push({
        name: e.url_name,
        url: e.url,
      });
      console.log("e=========", e);
    },
    submitUpload() {
      if (this.uploadFileList.length === 0) {
        this.$message.warning("请选择要上传的文件");
        return;
      }
      this.$API.saveSignature({
        arrange_xid: this.currentUploadRow.arrange_xid,
        signature_url:this.uploadFileList[0].url,
      }).then(res => {
               this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.uploadDialogVisible = false
          this.filter.currPage = 1;
        this.getList()
        console.log("res=========", res);
      })
    },
    closeUploadDialog() {
      this.uploadDialogVisible = false;
      this.uploadFileList = [];
    },
        getStatusText(status) {
      const statusMap = {
        0: '未开始',
        1: '进行中',
        2: '已结束'
      };
      return statusMap[status] || status;
    },
    getStatusStyle(status) {
      const styleMap = {
        0: {
          background: "#FEE2E2",
          color: "#DC2626",
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: "14px",
          display: "inline-block",
        },
        1: {
          background: "#FEF3C7",
          color: "#D97706",
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: "14px",
          display: "inline-block",
        },
        2: {
          background: "#F2F3F5",
          color: "#6B7280",
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: "14px",
          display: "inline-block",
        },
      };
      return styleMap[status] || {};
    },
         sizePagination(e) {
      this.filter.currPage = e
      this.getList()
    },
    currentPagination(e) {
      this.filter.currPage = e
      this.getList()
    },
    getList() {
      this.$API.getExpertScore(this.filter).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.pageInfo.allRows;
      });
    },
    handleRow(type, row) {
      switch (type) {
        case "look":
          this.$router.push({ path: "/bgManage/judge/scoringTable", query: { project_xid: row.project_xid ,xid: row.xid,isLook:this.judgeInfo.is_lock,status:row.status}});
          break;
        case "upload":
         this.currentUploadRow = row;
          this.uploadDialogVisible = true;
          break;
        case "goScore":
          this.$router.push("/bgManage/judge/scoringTable");
          break;
        case "goPs":
          if(this.tableData.length==0){
            return this.$message.warning("暂无打印数据")
          }
           this.$router.push({ path: "/bgManage/judge/expertReviewList", query: { xid:this.filter.xid ,expert_xid:this.tableData[0].expert_xid}});
          break;
        case "goBack":
          this.$router.go(-1);
          break;
      }
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-upload {
  width: 100%;
}
::v-deep .el-upload-dragger {
  width: 100%;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
.countNumber {
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #515A6E;
}
.paginBox {
display: flex;
justify-content: end;
padding: 0 20px 20px 0;
align-items: center;
margin-top: 20px;
width: 100%;
}

::v-deep .el-pagination.is-background .btn-prev {
background: none;
}

::v-deep .el-pagination .btn-next .el-icon {
font-size: 18px;
}

::v-deep .el-pagination .btn-prev .el-icon {
font-size: 18px;
}

::v-deep .btn-next {
width: 36px;
height: 36px;
background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}

::v-deep .btn-prev {
width: 36px;
height: 36px;
background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
background: #FFFFFF;
border-radius: 3px 3px 3px 3px;
border: 1px solid #2F86FF;
font-weight: 400;
font-size: 14px;
color: #2F86FF;
text-align: center;
font-style: normal;
text-transform: none;
}

::v-deep .el-pagination.is-background .el-pager li {
border-radius: 3px 3px 3px 3px;
border: 1px solid #B4B4B4;
background: none;
width: 36px;
height: 36px;
font-weight: 400;
font-size: 14px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
line-height: 35px;
}
.status {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  width: 72px;
  height: 28px;
  line-height: 28px;
  margin-left: 130px;
  text-align: center;
}
.nameTitle{
   font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #111827;
  margin-right: 50px;
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.name {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #111827;
  margin-right: 50px;
}
.reviewListContent {
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 20px 30px;
}
.reviewListLeft {
  display: flex;
  align-items: center;
}
.headImg {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  margin: 0 50px;
}
.reviewListBtn {
  display: flex;
  justify-content: end;
  margin-bottom: 30px;
}
.goBackBtn {
  display: flex;
  justify-content: end;
  align-items: center;
  height: 100%;
  padding-right: 60px;
}
.goBack {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 60px;
  background: #000000;
  border-radius: 0px 0px 0px 0px;
}
::v-deep .el-table__header-wrapper th {
  background: #f2f5fb !important;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #111827;
}
.arrangeTitle {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #595959;
}
.arrangeListDiv {
  width: 100%;
  height: 700px;
  border-radius: 6px;
  background: #fff;
}
</style>
